import { render, staticRenderFns } from "./summList.vue?vue&type=template&id=dd4e47aa&"
import script from "./summList.vue?vue&type=script&lang=js&"
export * from "./summList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports